import { PromotionRecommendationsSortType, PromotionRecommendationsSortOption } from './types';

export const sortParamMap: Record<
  PromotionRecommendationsSortType,
  PromotionRecommendationsSortOption
> = {
  EXPECTED_BUSINESS_IMPACT_DESC: {
    sortBy: 'EXPECTED_BUSINESS_IMPACT',
    sortingDirection: 'DESC',
  },
  EXPECTED_BUSINESS_IMPACT_ASC: {
    sortBy: 'EXPECTED_BUSINESS_IMPACT',
    sortingDirection: 'ASC',
  },
  SOLD_UNITS_DESC: {
    sortBy: 'SOLD_UNITS',
    sortingDirection: 'DESC',
  },
  SOLD_UNITS_ASC: {
    sortBy: 'SOLD_UNITS',
    sortingDirection: 'ASC',
  },
  TOTAL_REVENUE_DESC: {
    sortBy: 'TOTAL_REVENUE',
    sortingDirection: 'DESC',
  },
  TOTAL_REVENUE_ASC: {
    sortBy: 'TOTAL_REVENUE',
    sortingDirection: 'ASC',
  },
  PURE_PROFIT_MARGIN_DESC: {
    sortBy: 'PURE_PROFIT_MARGIN',
    sortingDirection: 'DESC',
  },
  PURE_PROFIT_MARGIN_ASC: {
    sortBy: 'PURE_PROFIT_MARGIN',
    sortingDirection: 'ASC',
  },
  PURE_PROFIT_MARGIN_DELTA_BPS_DESC: {
    sortBy: 'PURE_PROFIT_MARGIN_DELTA_BPS',
    sortingDirection: 'DESC',
  },
  PURE_PROFIT_MARGIN_DELTA_BPS_ASC: {
    sortBy: 'PURE_PROFIT_MARGIN_DELTA_BPS',
    sortingDirection: 'ASC',
  },
};
